import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, getSortState, JhiPagination, JhiItemCount } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './bursa-api-otc-cert.reducer';
import { IBursaAPIOtcCert } from 'app/shared/model/bursa-api-otc-cert.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const BursaAPIOtcCert = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  const bursaAPIOtcCertList = useAppSelector(state => state.bursaAPIOtcCert.entities);
  const loading = useAppSelector(state => state.bursaAPIOtcCert.loading);
  const totalItems = useAppSelector(state => state.bursaAPIOtcCert.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.push(`${props.location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [props.location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const { match } = props;

  return (
    <div>
      <h2 id="bursa-api-otc-cert-heading" data-cy="BursaAPIOtcCertHeading">
        <Translate contentKey="comexApp.bursaAPIOtcCert.home.title">Bursa API Otc Certs</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="primary" outline onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="comexApp.bursaAPIOtcCert.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="comexApp.bursaAPIOtcCert.home.createLabel">Create new Bursa API Otc Cert</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {bursaAPIOtcCertList && bursaAPIOtcCertList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="comexApp.bursaAPIOtcCert.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('endpointURL')}>
                  <Translate contentKey="comexApp.bursaAPIOtcCert.endpointURL">Endpoint URL</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('ecertNo')}>
                  <Translate contentKey="comexApp.bursaAPIOtcCert.ecertNo">Ecert No</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('memberShortName')}>
                  <Translate contentKey="comexApp.bursaAPIOtcCert.memberShortName">Member Short Name</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('successYN')}>
                  <Translate contentKey="comexApp.bursaAPIOtcCert.successYN">Success YN</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('msg')}>
                  <Translate contentKey="comexApp.bursaAPIOtcCert.msg">Msg</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('seller')}>
                  <Translate contentKey="comexApp.bursaAPIOtcCert.seller">Seller</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('buyer')}>
                  <Translate contentKey="comexApp.bursaAPIOtcCert.buyer">Buyer</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('totalValue')}>
                  <Translate contentKey="comexApp.bursaAPIOtcCert.totalValue">Total Value</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('currency')}>
                  <Translate contentKey="comexApp.bursaAPIOtcCert.currency">Currency</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('price')}>
                  <Translate contentKey="comexApp.bursaAPIOtcCert.price">Price</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('priceMYR')}>
                  <Translate contentKey="comexApp.bursaAPIOtcCert.priceMYR">Price MYR</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('murabahValue')}>
                  <Translate contentKey="comexApp.bursaAPIOtcCert.murabahValue">Murabah Value</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('reportingTimeDate')}>
                  <Translate contentKey="comexApp.bursaAPIOtcCert.reportingTimeDate">Reporting Time Date</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('valueDate')}>
                  <Translate contentKey="comexApp.bursaAPIOtcCert.valueDate">Value Date</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('pName')}>
                  <Translate contentKey="comexApp.bursaAPIOtcCert.pName">P Name</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('pVolume')}>
                  <Translate contentKey="comexApp.bursaAPIOtcCert.pVolume">P Volume</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('supplier')}>
                  <Translate contentKey="comexApp.bursaAPIOtcCert.supplier">Supplier</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('volume')}>
                  <Translate contentKey="comexApp.bursaAPIOtcCert.volume">Volume</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {bursaAPIOtcCertList.map((bursaAPIOtcCert, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${bursaAPIOtcCert.id}`} color="link" size="sm">
                      {bursaAPIOtcCert.id}
                    </Button>
                  </td>
                  <td>{bursaAPIOtcCert.endpointURL}</td>
                  <td>{bursaAPIOtcCert.ecertNo}</td>
                  <td>{bursaAPIOtcCert.memberShortName}</td>
                  <td>{bursaAPIOtcCert.successYN}</td>
                  <td>{bursaAPIOtcCert.msg}</td>
                  <td>{bursaAPIOtcCert.seller}</td>
                  <td>{bursaAPIOtcCert.buyer}</td>
                  <td>{bursaAPIOtcCert.totalValue}</td>
                  <td>{bursaAPIOtcCert.currency}</td>
                  <td>{bursaAPIOtcCert.price}</td>
                  <td>{bursaAPIOtcCert.priceMYR}</td>
                  <td>{bursaAPIOtcCert.murabahValue}</td>
                  <td>{bursaAPIOtcCert.reportingTimeDate}</td>
                  <td>{bursaAPIOtcCert.valueDate}</td>
                  <td>{bursaAPIOtcCert.pName}</td>
                  <td>{bursaAPIOtcCert.pVolume}</td>
                  <td>{bursaAPIOtcCert.supplier}</td>
                  <td>{bursaAPIOtcCert.volume}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${bursaAPIOtcCert.id}`} size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      &nbsp;
                      <Button
                        tag={Link}
                        to={`${match.url}/${bursaAPIOtcCert.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      &nbsp;
                      <Button
                        tag={Link}
                        to={`${match.url}/${bursaAPIOtcCert.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="comexApp.bursaAPIOtcCert.home.notFound">No Bursa API Otc Certs found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={bursaAPIOtcCertList && bursaAPIOtcCertList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default BursaAPIOtcCert;
